/**
 * Het groepje en de tijdklok, zoals ze boven de chat en boven het
 * argumentenformulier staan.
 */
import React from 'react';
import { User } from 'lucide-react';
import { Portret } from '../../../components/Portret';
import { basis } from '../stijlen';

/** Naam en icoon van het groepje, met de leden eronder als het er meer zijn. */
export function GroepBadge({ groepje, discussion }) {
  return (
    <div style={basis.groupBadge}>
      <span>{groepje.avatar} {groepje.naam}</span>
      {discussion?.leden?.length > 1 && (
        <span style={basis.groupLeden}>{discussion.leden.map(l => l.naam).join(' • ')}</span>
      )}
    </div>
  );
}

/** m:ss, rood in de laatste minuut. Niets als er geen klok loopt. */
export function Tijdklok({ seconden }) {
  if (seconden === null) return null;
  return (
    <div style={seconden < 60 ? basis.timerWarning : basis.timer}>
      {Math.floor(seconden / 60)}:{(seconden % 60).toString().padStart(2, '0')}
    </div>
  );
}

/**
 * Het portret van een persona, of het icoon van een persoon als er geen
 * portret is. Zonder terugval zou een lege basisset de chat kaal maken.
 */
export function PersonaBeeld({ apiUrl, persona, grootte }) {
  return (
    <Portret apiUrl={apiUrl} naam={persona?.portret} grootte={grootte} stijl={{ display: 'block' }}
      terugval={<User size={Math.round(grootte * 0.5)} />} />
  );
}
